module.exports = __webpack_public_path__ + "static/media/settings.bc93f8b5.svg";